import client from 'services';

export async function getBackboneData() {
  return await client({ method: 'get', url: '/backbones' });
}

export async function getMHCAlleles() {
  return await client({ method: 'get', url: '/backbones/mhc_alleles' });
}
